import { WTextfield } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'

const CompanyNameField: FunctionComponent = () => {
  const {
    register,
    setValue,
    clearErrors,
    trigger,
    formState: { errors }
  } = useFormContext<{
    companyName: string
  }>()

  return (
    <>
      <WTextfield
        {...register('companyName')}
        placeholder='Nome da empresa'
        invalid={!!errors.companyName}
        errorText={errors.companyName?.message}
        onWChange={ev => setValue('companyName', ev.detail)}
        onInput={() => clearErrors('companyName')}
        onBlur={() => trigger('companyName')}
      />
    </>
  )
}

export { CompanyNameField }
